import React from 'react';
import { Checkbox, FormControlLabel, Grid, TextField } from '@material-ui/core';
import { KeyboardTimePicker } from '@material-ui/pickers';
import { useFormContext } from '../FormContext';
import FormConfigRequired from './FormConfigRequired';
import FormConfigTitleDescription from './FormConfigTitleDescription';
const FormConfigTime = () => {
    var _a, _b, _c, _d;
    const { formState, setFormState, notifyFormEdit } = useFormContext();
    const element = formState.selectedFormElement;
    if (!element.config)
        element.config = {};
    const allowSeconds = (_a = element.config) === null || _a === void 0 ? void 0 : _a.allowSeconds;
    const pickerView = allowSeconds
        ? ['hours', 'minutes', 'seconds']
        : ['hours', 'minutes'];
    return (React.createElement(React.Fragment, null,
        React.createElement(FormConfigTitleDescription, null),
        React.createElement(FormConfigRequired, null),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(KeyboardTimePicker, { fullWidth: true, clearable: true, inputVariant: 'outlined', margin: 'normal', label: 'Min Time', value: ((_b = element.config) === null || _b === void 0 ? void 0 : _b.minTime) || null, views: pickerView, onChange: time => {
                    element.config.minTime = time;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } }),
            React.createElement(KeyboardTimePicker, { fullWidth: true, clearable: true, inputVariant: 'outlined', margin: 'normal', label: 'Max Time', value: ((_c = element.config) === null || _c === void 0 ? void 0 : _c.maxTime) || null, views: pickerView, onChange: time => {
                    element.config.maxTime = time;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } }),
            React.createElement(FormControlLabel, { label: 'Seconds', control: React.createElement(Checkbox, { checked: allowSeconds, color: 'primary', onChange: () => {
                        element.config.allowSeconds = !allowSeconds;
                        setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                        notifyFormEdit();
                    } }) }),
            React.createElement(TextField, { fullWidth: true, variant: 'outlined', margin: 'normal', type: 'number', label: 'Time Increament (minute)', placeholder: 'Time Increment (minute)', InputProps: { inputProps: { min: 1, max: 60 } }, defaultValue: ((_d = element.config) === null || _d === void 0 ? void 0 : _d.timeIncrement) || 1, onChange: event => {
                    element.config.timeIncrement = parseInt(event.target.value);
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } }))));
};
export default FormConfigTime;
//# sourceMappingURL=FormConfigTime.js.map